<h2 mat-dialog-title>User Exists</h2>
<mat-dialog-content
    >This user is already a primary customer on another account. Would you like to continue adding a second account or go to the existing
    account?</mat-dialog-content
>
<mat-dialog-actions>
    <button mat-button [mat-dialog-close]="true">Go To Account</button>
    <button mat-button [mat-dialog-close]="false">Continue</button>
</mat-dialog-actions>
